/**
 * 模块说明： 无菜单，且有页面框架
 */
import { RouterType } from '@/types/router'

export const noMenuRoute: RouterType[] = [
  {
    path: '/noMenu',
    redirect: '/login',
    name: 'noMenu',
    component: () => import('@/views/register/frame.vue'),
    children: [
      {
        path: 'registerMaterialPage',
        component: () => import('@/views/register/materialPage.vue'),
        name: 'registerMaterialPage',
        meta: { title: '欢迎开通投资账户' }
      }
    ]
  },
  {
    path: '/adminRegister',
    component: () => import('@/views/register/adminRegister.vue'),
    name: 'adminRegister',
    meta: { title: '注册' }
  },
  {
    path: '/accountOpenType',
    component: () => import('@/views/register/accountOpenType.vue'),
    name: 'accountOpenType',
    meta: { title: '注册' }
  },
  {
    path: '/resetPassword',
    component: () => import('@/views/myAccount/resetPassword.vue'),
    name: 'resetPassworHome'
  },
  {
    path: '/redirect',
    component: () => import('@/views/layout/components/redirect.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/footerWebs/about.vue')
  },
  {
    path: '/authJump',
    component: () => import('@/views/login/authorizationJump..vue') // 权限跳转页面
  },
  {
    path: '/resetSuccess',
    component: () => import('@/views/myAccount/changeSuccess.vue'),
    name: 'resetSuccessHome'
  },
  {
    path: '/confirmSheet',
    component: () => import('@/views/layout/frameless/confirmSheet.vue') // 无框架确认单信息
  },
  {
    path: '/eleSignProtoco',
    name: 'eleSignProtoco',
    component: () => import('@/views/myAccount/eleSignaProtoco.vue')
  }
]
